/**
 * Figma `Page spacer / M` (symbol 2354:55430): 130px from the bottom of the tab
 * pills to the top of a tab's first content block. One constant because the gap
 * has to read the same on every tab — they were each carrying their own 3rem.
 *
 * The page title's own line-height (11.25rem on a 12.5rem font, see
 * {@link PAGE_TITLE_TYPE}) is tight enough that the caps start within ~2px of the
 * text box, so the letters land visually on the spacer's edge rather than
 * floating below it on a band of leading.
 */
export const TAB_CONTENT_GAP = 'md:pt-[8.125rem]';

/**
 * The shared page-title type (Figma 2354:55431): 200px Neue Haas over a 180px
 * line box, tracking -8.4px. Kept here because the grid tabs had drifted onto a
 * looser `leading-[0.92] tracking-[-0.12rem]` while the About / Contact /
 * Downloads titles already used the Figma values.
 */
export const PAGE_TITLE_TYPE =
    'md:text-[12.5rem] md:leading-[11.25rem] md:tracking-[-0.525rem]';

/**
 * Mobile override for a `SectionLabel` that a tab actually shows on mobile.
 *
 * `SectionLabel` is desktop-first — its mobile size is `2.21vw`, which is ~9px at
 * 414 because on the homepage the label only ever renders at desktop widths. A
 * label that survives to mobile has to read as a heading instead, so this matches
 * the numbered accordion's mobile trigger: 16px, medium, default tracking.
 */
export const MOBILE_SECTION_LABEL =
    'max-md:text-base max-md:font-medium max-md:tracking-normal';
